document.addEventListener("DOMContentLoaded", function () {
  const currentUrl = window.location.href;

  const container = document.querySelector('.learn-gas-bloating-sticky');
  if (!container) return;

  const links = container.querySelectorAll('a');

  links.forEach(link => {
    const linkUrl = link.href;

    // Exact match OR partial match (you can adjust this)
    if (currentUrl === linkUrl || currentUrl.includes(linkUrl)) {
      link.classList.add('sticky-active-link');
    } else {
      link.classList.remove('sticky-active-link');
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const currentUrl = window.location.href;

  const sections = document.querySelectorAll('.icon-tabs-section');

  sections.forEach(section => {
    const items = section.querySelectorAll('.icon-tabs__item');

    items.forEach(item => {
      const onclickAttr = item.getAttribute("onclick");

      if (!onclickAttr) return;

      // Extract URL from onclick="window.location='URL'"
      const match = onclickAttr.match(/window\.location='(.*?)'/);

      if (!match || !match[1]) return;

      const linkUrl = match[1];

      // Match logic (same as your sticky script)
      if (currentUrl === linkUrl || currentUrl.includes(linkUrl)) {
        item.classList.add('icon-tabs__item--active');
      } else {
        item.classList.remove('icon-tabs__item--active');
      }
    });
  });
});


// Convert headings to Title Case while preserving medical acronyms (e.g. ADHD, SIBO, IBS, GERD)

// document.querySelectorAll('.cs-blog-post-content h2').forEach((heading) => {
//   heading.textContent = heading.textContent.replace(/\b\w+\b/g, (word) => {
//     // Keep acronyms like PPI, PPIs, API, APIs, SEO unchanged
//     if (/^[A-Z]{2,}s?$/.test(word)) {
//       return word;
//     }

//     // Convert remaining words to Title Case
//     return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
//   });
// });

document.querySelectorAll('.cs-blog-post-content h2').forEach((heading) => {
  heading.textContent = heading.textContent.replace(
    /[A-Za-z]+(?:['’][A-Za-z]+)?/g,
    (word) => {
      // Keep acronyms like PPI, PPIs, API, APIs, SEO unchanged
      if (/^[A-Z]{2,}s?$/.test(word)) {
        return word;
      }

      // Handle contractions: Isn't, Can't, Won't, You're, etc.
      if (word.includes("'") || word.includes("’")) {
        const apostrophe = word.includes("’") ? "’" : "'";
        const parts = word.split(apostrophe);

        return (
          parts[0].charAt(0).toUpperCase() +
          parts[0].slice(1).toLowerCase() +
          apostrophe +
          parts[1].toLowerCase()
        );
      }

      // Normal Title Case
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }
  );
});


// Check if the Shop Now button exists on the current page

const shopNowButton = document.querySelector('.btn-shop-now');

if (shopNowButton) {
  shopNowButton.addEventListener('click', function (e) {
    e.preventDefault();

    const target = document.querySelector('.recharge-subscription-widget');

    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  });
}

  // Find all References, FAQs, and Audio blocks

  document.addEventListener('DOMContentLoaded', function () {
  const blocks = document.querySelectorAll(
    '.cs-references-block, .cs-faqs-block, .cs-audio-block'
  );

  blocks.forEach(function (block) {
    if (!block.textContent.trim() && !block.querySelector('img, video, audio, iframe')) {
      block.style.display = 'none';
    }
  });
});

